import { ApiRestService } from './../_service/api-rest.service';
import { ToastrService } from 'ngx-toastr';
import { ApiRestService as FileApiRestService } from './../../shared/_services/api-rest.service';
import { DownloadService } from './../../shared/_services/download.service';
import { Azienda } from './../models/Azienda';
import { AziendeStoreService } from './../_service/aziende-store.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Attivita } from './../models/Attivita';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-Crm',
    templateUrl: './crm.component.html'
})
export class CrmComponent implements OnInit {
    @Input() useStore: boolean = false;
    @Input() clienteSelezionato: Azienda;
    subscriptions: Subscription = new Subscription();
    AttivitaSelezionata: Attivita;
    collectionSize = 0;
    closedCollectionSize = 0;
    openedCollectionSize = 0;
    AttivitaFiltrate: Attivita[] = [];
    @Input() Attivita: Attivita[] = [];
    @Output() AttivitaChange = new EventEmitter<Attivita>();
    @Output() Refresh = new EventEmitter<any>();

    EnvData = environment.TaskAddon['Crm'];
    constructor(private modalService: NgbModal,
        private clientiStore: AziendeStoreService,
        private downloadService: DownloadService,
        private fileApiRestService: FileApiRestService,
        private ApiRestService: ApiRestService,
        private toastService: ToastrService
    ) {
        
    }
    ngOnInit() {
        this.subscriptions.add(this.clientiStore.$attivitaSelezionata.subscribe((item) => this.AttivitaSelezionata = item ?? this.AttivitaSelezionata));
        if (this.useStore)
            this.subscriptions.add(this.clientiStore.$attivita.subscribe((items) => {
                this.Attivita = items;
                this.InitList(items);
            }));
        else
            this.InitList(this.Attivita);
       
    }


    InitList(Attivita: Attivita[]) {
        if (Attivita?.length) {
            this.collectionSize = Attivita.length;
            this.openedCollectionSize = Attivita.filter(x => !x.att_chiusa).length
            this.closedCollectionSize = Attivita.filter(x => x.att_chiusa).length
        }
        this.AttivitaFiltrate = Object.assign([], Attivita);
    }



    



    download(item: Attivita) {
        var idAllegato = parseInt(item.allegato);
        if (!isNaN(idAllegato)) {
            this.fileApiRestService.downloadFle(idAllegato).subscribe(data => {
                this.downloadService.downloadFile(data)
            });
        } else {
            this.toastService.info("Allegato non disponibile", "Ooops!")
        }
    }

    delete(item) {
        if (confirm("Sei sicuro di voler eliminare questa attività?"))
            this.clientiStore.deleteAttivita(item, this.clienteSelezionato);
    }
    saveModalButton() {
        var item = this.AttivitaSelezionata;
        item.cliente = this.clienteSelezionato?.id;
        if (this.EnvData['SaveMap'])
            item = this.EnvData['SaveMap'](item);
        if (!this.AttivitaSelezionata?.id)
            this.ApiRestService.addNewAttivita(item).subscribe((data) => {
                this.Saved(data);
            });
        else {
            this.ApiRestService.updateAttivita(item).subscribe((data) => {
                this.Saved(data);
            });
        }
    }
    Saved(data) {
        this.Refresh.emit(data);
        this.clientiStore.Refresh(this.clienteSelezionato);
        this.closeBtnClick();
    }
   
    openModal(targetModal: NgbModal) {
        this.modalService.open(targetModal, {
            centered: true,
            backdrop: 'static'
        });
        this.AttivitaSelezionata = new Attivita();
    }
    openEditModal(targetModal: NgbModal, item: Attivita) {
        this.modalService.open(targetModal, {
            centered: true,
            backdrop: 'static'
        });
        this.AttivitaSelezionata = Object.assign({}, item);
    }
    closeBtnClick() {
        this.modalService.dismissAll();
    }
    filtroConcluse() {
        this.AttivitaFiltrate = this.Attivita.filter(x => x.att_chiusa);
    }
    filtroAperte() {
        this.AttivitaFiltrate = this.Attivita.filter(x => !x.att_chiusa);
    }
}
